var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 0C22.5 0 0 22.5 0 50.0001C0 77.5002 22.5 100 50.0001 100C77.5002 100 100 77.5002 100 50.0001C100 22.5 77.5 0 50.0001 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9806 47.4521C77.9806 49.1748 76.5222 50.5242 74.8694 50.5242H71.7583L71.8264 65.8559C71.8264 66.1143 71.8069 66.3727 71.7778 66.6311V68.1719C71.7778 70.2869 70.0375 72 67.8889 72H66.3333C66.2264 72 66.1194 72 66.0125 71.9904C65.8764 72 65.7403 72 65.6042 72H62.4444H60.1111C57.9625 72 56.2222 70.2869 56.2222 68.1719V65.875V59.75C56.2222 58.0561 54.8319 56.6875 53.1111 56.6875H46.8889C45.1681 56.6875 43.7778 58.0561 43.7778 59.75V65.875V68.1719C43.7778 70.2869 42.0375 72 39.8889 72H37.5556H34.4542C34.3083 72 34.1625 71.9904 34.0167 71.9809C33.9 71.9904 33.7833 72 33.6667 72H32.1111C29.9625 72 28.2222 70.2869 28.2222 68.1719V57.4531C28.2222 57.367 28.2222 57.2713 28.2319 57.1852V50.5242H25.1111C23.3611 50.5242 22 49.1844 22 47.4521C22 46.5908 22.2917 45.8252 22.9722 45.1553L47.9 23.7656C48.5806 23.0957 49.3583 23 50.0389 23C50.7194 23 51.4972 23.1914 52.0806 23.6699L76.9111 45.1553C77.6889 45.8252 78.0778 46.5908 77.9806 47.4521Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 49,
    fill: "white",
    transform: "translate(22 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.d8fc1d353b50048fe052ad0448e06825.svg";
export { ForwardRef as ReactComponent };